module.exports = __webpack_public_path__ + "static/media/ertax.499cd542.svg";